import { LOGOS } from '../../constants/imageConstants';

export const AuthLayout = ({ children }) => {
  return (
    <div className="flex items-center justify-center h-screen">
      <div className="w-full max-w-md p-4">
        <div className="mb-4 flex items-center justify-center gap-3">
          <img src={LOGOS.AUTH_LOGO} alt="Logo" className='max-w-44'/>
        </div>
        {children}
      </div>
    </div>
  );
};